export default __webpack_public_path__ + "static/user-paths-dark-57cdef2dd41b8de7e209e11c16e792c3.png";